<!--
 * @Descripttion: 
 * @version: 
 * @Author: Raoxf
 * @Date: 2022-05-29 13:54:31
 * @LastEditors: Raoxf
 * @LastEditTime: 2023-04-08 08:48:51
-->
<template>
  <div>
    <search-area tabName="商户列表" searchAdd @search="search" @add="add">
      <Form
        ref="searchParam"
        :model="searchParam"
        :label-width="55"
        inline
        label-position="right"
        label-colon
      >
        <FormItem label="商户名称" prop="name" :label-width="105">
          <Input
            :disabled="isCompany"
            v-model="searchParam.companyName"
            placeholder="请输入商户名称"
            style="width: 200px"
            clearable
          ></Input>
        </FormItem>
      </Form>
    </search-area>
    <table-area
      :columns="columns"
      :data="companyList"
      :total="total"
      @search="search"
      :pageNum="searchParam.pageNum"
      :pageSize="searchParam.pageSize"
    ></table-area>
    <el-dialog
      title="新增商户"
      :visible.sync="addMerchantDialog"
      width="60%"
      :before-close="handleClose"
    >
      <el-form
        ref="addMerchantForm"
        :model="addInfo"
        label-width="120px"
        :rules="rules"
      >
        <el-form-item label="公司名称" prop="name">
          <el-input
            v-model="addInfo.name"
            autocomplete="off"
            placeholder="请输入公司名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="公司唯一编码" prop="code">
          <el-input
            v-model="addInfo.code"
            autocomplete="off"
            placeholder="请输入公司唯一编码"
          ></el-input>
        </el-form-item>
        <el-form-item label="公司法人" prop="legalPersonName">
          <el-input
            v-model="addInfo.legalPersonName"
            autocomplete="off"
            placeholder="请输入公司法人姓名"
          ></el-input>
        </el-form-item>
        <el-form-item label="法人手机号" prop="legalPersonPhone">
          <el-input
            v-model="addInfo.legalPersonPhone"
            placeholder="请输入公司法人手机号"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="提现手机号" prop="withdrawPhone">
          <el-input
            v-model="addInfo.withdrawPhone"
            placeholder="请输入提现手机号"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="营业执照" prop="license">
          <el-upload
            class="form-upload"
            ref="uploadcover"
            action="#"
            name="coverUrl"
            accept=".png, .jpg"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="handManyFile"
          >
            <el-button slot="trigger" size="small" type="primary"
              >上传营业执照
            </el-button>
          </el-upload>
          <div
            v-if="addInfo.license"
            style="display: flex; gap: 10px; flex-wrap: wrap; margin-top: 10px"
          >
            <span
              v-for="(img, index) in addInfo.license.split(',')"
              :key="index"
              style="
                display: inline-block;
                width: 100px;
                height: 100px;
                position: relative;
              "
            >
              <img
                @click="deleteImg(index)"
                src="@/assets/delete.png"
                style="
                  height: 20px;
                  width: 20px;
                  position: absolute;
                  right: 0;
                  top: 0;
                  z-index: 10;
                  cursor: pointer;
                "
              />
              <el-popover placement="left" title="" trigger="hover" width="300">
                <img :src="formatImg(img.trim())" width="100%" />
                <img
                  slot="reference"
                  :src="formatImg(img.trim())"
                  :alt="`营业执照${index + 1}`"
                  style="
                    width: 100px;
                    height: 100px;
                    object-fit: cover;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                    cursor: pointer;
                  "
                />
              </el-popover>
            </span>
          </div>
        </el-form-item>
        <el-form-item label="法人身份证照片" prop="idCardUrl">
          <el-upload
            class="form-upload"
            ref="uploadIdCard"
            action="#"
            name="idCardUrl"
            accept=".png, .jpg"
            :show-file-list="false"
            :auto-upload="false"
            :on-change="onUploadIdCard"
          >
            <el-button slot="trigger" size="small" type="primary"
              >上传法人身份证
            </el-button>
          </el-upload>
          <div
            v-if="addInfo.idCardUrl"
            style="display: flex; gap: 10px; flex-wrap: wrap; margin-top: 10px"
          >
            <span
              v-for="(img, index) in addInfo.idCardUrl.split(',')"
              :key="index"
              style="
                display: inline-block;
                width: 100px;
                height: 100px;
                position: relative;
              "
            >
              <img
                @click="deleteIdCard(index)"
                src="@/assets/delete.png"
                style="
                  height: 20px;
                  width: 20px;
                  position: absolute;
                  right: 0;
                  top: 0;
                  z-index: 10;
                  cursor: pointer;
                "
              />
              <el-popover placement="left" title="" trigger="hover" width="300">
                <img :src="formatImg(img.trim())" width="100%" />
                <img
                  slot="reference"
                  :src="formatImg(img.trim())"
                  :alt="`身份证${index + 1}`"
                  style="
                    width: 100px;
                    height: 100px;
                    object-fit: cover;
                    border: 1px solid #ddd;
                    border-radius: 4px;
                    cursor: pointer;
                  "
                />
              </el-popover>
            </span>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCancelAddMerchant">取 消</el-button>
        <el-button type="primary" @click="onConfirm">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="审核商户"
      :visible.sync="showCompanyReviewDialog"
      width="400px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        ref="companyReviewFormData"
        :model="companyReviewFormData"
        :rules="companyReviewRule"
        label-width="120px"
      >
        <el-form-item label="审核状态" prop="state">
          <el-select
            v-model="companyReviewFormData.state"
            placeholder="请选择审核状态"
          >
            <el-option label="已入驻" value="1" />
            <el-option label="拒绝" value="2" />
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="String(companyReviewFormData.state) === '2'"
          label="拒绝原因"
          prop="reason"
        >
          <el-input
            v-model="companyReviewFormData.reason"
            placeholder="请输入拒绝原因"
            maxlength="100"
            show-word-limit
          />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="onCloseCompanyReview">取 消</el-button>
        <el-button type="primary" @click="onSubmitCompanyReview"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import columns from "./column-config";
export default {
  data() {
    return {
      columns: columns(this),
      // 列表数据总数
      total: 1,
      // 加载中
      loading: false,
      // 搜索参数
      searchParam: {
        companyName: "",
        currentPage: 1,
        pageSize: 10,
      },
      companyList: [],
      addMerchantDialog: false,
      addInfo: this.createAddInfo(),
      showCompanyReviewDialog: false,
      companyReviewFormData: {
        companyId: "",
        state: "",
        reason: "",
      },
      companyReviewRule: {
        state: [
          { required: true, message: "请选择审核状态", trigger: "change" },
        ],
        reason: [
          {
            validator: (rule, value, cb) => {
              if (String(this.companyReviewFormData.state) === "2" && !value) {
                return cb(new Error("请输入拒绝原因"));
              }
              cb();
            },
            trigger: "blur",
          },
        ],
      },
      rules: {
        name: [{ required: true, message: "请输入公司全称", trigger: "blur" }],
        code: [
          { required: true, message: "请输入公司唯一编码", trigger: "blur" },
        ],
        legalPersonName: [
          { required: true, message: "请输入法人姓名", trigger: "change" },
        ],
        legalPersonPhone: [
          { required: true, message: "请输入法人手机号", trigger: "change" },
        ],
      },
      isCompany: false, // 是否是商户账号
    };
  },
  computed: {},
  async created() {
    if (window.userInfo.companyId) {
      this.isCompany = true;
      let data = await this.$get("/company/all");
      this.searchParam.companyName = data.filter(
        (l) => l.id == window.userInfo.companyId,
      )[0].name;
    }
    this.getCompanyList();
  },
  methods: {
    formatImg(url) {
      if (url.indexOf("http") > -1) {
        return url;
      }
      return this.host + url;
    },
    // 执行搜索
    search() {
      this.searchParam.currentPage = 1;
      this.getCompanyList();
    },
    // 获取商户列表
    async getCompanyList() {
      this.loading = true;
      let { list, total } = await this.$post("/company/listByPage", {
        ...this.searchParam,
      });
      this.companyList = list;
      this.total = total;
    },
    add() {
      if (this.isCompany) return;
      this.addInfo = this.createAddInfo();
      this.addMerchantDialog = true;
    },
    createAddInfo() {
      return {
        code: "",
        name: "",
        legalPersonName: "", // 法人姓名
        legalPersonPhone: "", // 法人手机号
        withdrawPhone: "", // 提现手机号
        license: "", // 营业执照
        lienseUrl: "", // 营业执照
        idCardUrl: "", // 法人身份证照片
      };
    },
    resetAddInfo() {
      this.addInfo = this.createAddInfo();
      this.$nextTick(() => {
        this.$refs.addMerchantForm.clearValidate();
        this.$refs.uploadcover.clearFiles();
        this.$refs.uploadIdCard.clearFiles();
      });
    },
    closeAddMerchantDialog() {
      this.addMerchantDialog = false;
      this.resetAddInfo();
    },
    onCancelAddMerchant() {
      this.$confirm("您还未提交，确认关闭?")
        .then((_) => {
          this.closeAddMerchantDialog();
        })
        .catch((_) => {});
    },
    handleClose(done) {
      this.$confirm("您还未提交，确认关闭?")
        .then((_) => {
          done();
          this.resetAddInfo();
        })
        .catch((_) => {});
    },
    onCloseCompanyReview() {
      this.showCompanyReviewDialog = false;
      this.companyReviewFormData = { companyId: "", state: "", reason: "" };
      if (this.$refs.companyReviewFormData) {
        this.$refs.companyReviewFormData.resetFields();
      }
    },
    onSubmitCompanyReview() {
      this.$refs.companyReviewFormData.validate(async (valid) => {
        if (!valid) return;
        const payload = {
          companyId: this.companyReviewFormData.companyId,
          state: this.companyReviewFormData.state,
        };
        if (String(this.companyReviewFormData.state) === "2") {
          payload.reason = this.companyReviewFormData.reason;
        }
        await this.$post("/company/save", payload);
        this.$message.success("审核成功");
        this.onCloseCompanyReview();
        this.getCompanyList();
      });
    },
    // 上传营业执照
    async handManyFile(file, fileList, type) {
      var param = new FormData();
      param.append("file", file.raw);
      let data = await this.$upload("/File/upload", param);
      // 营业执照图 - 追加到现有图片
      if (this.addInfo.license) {
        this.addInfo.license = this.addInfo.license + "," + data;
      } else {
        this.addInfo.license = data;
      }
      this.$forceUpdate();
    },
    // 上传法人身份证
    async onUploadIdCard(file) {
      const param = new FormData();
      param.append("file", file.raw);
      const data = await this.$upload("/File/upload", param);
      // 法人身份证 - 追加到现有图片
      if (this.addInfo.idCardUrl) {
        this.addInfo.idCardUrl = this.addInfo.idCardUrl + "," + data;
      } else {
        this.addInfo.idCardUrl = data;
      }
      this.$forceUpdate();
    },
    deleteImg(index) {
      this.$confirm("确认删除该图片, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 删除指定索引的图片
          const images = this.addInfo.license.split(",");
          images.splice(index, 1);
          this.addInfo.license = images.filter((img) => img.trim()).join(",");
          this.$forceUpdate();
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 删除法人身份证
    deleteIdCard(index) {
      this.$confirm("确认删除该图片, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 删除指定索引的图片
          const images = this.addInfo.idCardUrl.split(",");
          images.splice(index, 1);
          this.addInfo.idCardUrl = images.filter((img) => img.trim()).join(",");
          this.$forceUpdate();
          this.$message({ type: "success", message: "删除成功!" });
        })
        .catch(() => {
          this.$message({ type: "info", message: "已取消删除" });
        });
    },
    // 确认新增/编辑公司信息
    async onConfirm() {
      let data = await this.$post("/company/save", this.addInfo);
      this.$message({ type: "info", message: "保存成功" });
      this.closeAddMerchantDialog();
      this.getCompanyList();
    },
  },
  components: {},
};
</script>

<style lang="stylus" scoped></style>
